import { useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/esm/Modal";
import Form from "react-bootstrap/Form";
import { Notificar } from "../../Comunes/Notificador";
import moment from "moment";
import DatePicker from "react-datepicker";

function ModificarOperacionNoReportadaModal({
  operacionNoReportada,
  tiposOperacion,
  motivosLiquidacion,
  actualizarOperacion,
}) {
  const [show, setShow] = useState(false);
  const [operacionNoReportadaLocal, setOperacionNoReportadaLocal] =
    useState(operacionNoReportada);
  const motivosQueRequierenOperacionNueva = [3, 14];

  const handleClose = () => {
    setOperacionNoReportadaLocal(operacionNoReportada);
    setShow(false);
  };

  const handleShow = () => setShow(true);

  function manejarCambioDeSaldo(e) {
    let { name, value } = e.target;

    // Reemplaza las comas con puntos
    value = value.replace(/,/g, ".");
    if (!value || value.match(/^\d{0,20}(\.\d{0,2})?$/)) {
      setOperacionNoReportadaLocal({
        ...operacionNoReportadaLocal,
        [name]: value,
      });
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!datosValidos()) {
      return;
    }

    operacionNoReportadaLocal.indModificada = "N";
    operacionNoReportadaLocal.saldoPrincipalLiquidado = Number(
      operacionNoReportadaLocal.saldoPrincipalLiquidado
    );
    operacionNoReportadaLocal.saldoProductoLiquidado = Number(
      operacionNoReportadaLocal.saldoProductoLiquidado
    );

    if (
      !motivosQueRequierenOperacionNueva.includes(
        operacionNoReportadaLocal.motivoLiquidacion.codigo
      )
    ) {
      operacionNoReportadaLocal.operacionNueva = null;
    }

    actualizarOperacion(operacionNoReportadaLocal);
    handleClose();
  };

  function datosValidos() {
    if (!operacionNoReportadaLocal.fechaPeriodo) {
      Notificar("error", "El periodo es obligatorio.");
      return false;
    }

    if (!operacionNoReportadaLocal.fechaLiquidacion) {
      Notificar("error", "La fecha de liquidación es obligatoria.");
      return false;
    }

    if (
      motivosQueRequierenOperacionNueva.includes(
        operacionNoReportadaLocal.motivoLiquidacion.codigo
      ) &&
      !operacionNoReportadaLocal.operacionNueva
    ) {
      Notificar("error", "La operación nueva es obligatoria.");
      return false;
    }

    if (!operacionNoReportadaLocal.tipoOperacion?.codigo) {
      Notificar("error", "El tipo de operación es obligatorio.");
      return false;
    }

    return true;
  }

  return (
    <>
      <button
        className="btn btn-primary btn-sm"
        title="Modificar Operación No Reportada"
        onClick={handleShow}
      >
        <i className="fas fa-edit"></i>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Modificar Operación No Reportada</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="form-group">
              <label htmlFor="Operacion">Operación</label>
              <Form.Control
                className="form-control"
                name="Operacion"
                id="Operacion"
                disabled
                value={operacionNoReportadaLocal.operacion ?? ""}
              />
            </div>
            <div className="form-row">
              <div className="form-group col">
                <label htmlFor="periodo">Periodo</label>
                <DatePicker
                  placeholderText="Seleccione el periodo"
                  locale="es"
                  selected={
                    operacionNoReportadaLocal.fechaPeriodo
                      ? new Date(operacionNoReportadaLocal.fechaPeriodo)
                      : null
                  }
                  onChange={(fecha) =>
                    setOperacionNoReportadaLocal({
                      ...operacionNoReportadaLocal,
                      fechaPeriodo: moment(fecha).isValid()
                        ? moment(fecha).format("YYYY-MM-DDTHH:mm:ss")
                        : null,
                    })
                  }
                  id="periodo"
                  name="periodo"
                  dateFormat="MM/yyyy"
                  className="form-control"
                  wrapperClassName="w-100"
                  showMonthYearPicker
                  showFullMonthYearPicker
                  openToDate={
                    !operacionNoReportadaLocal.fechaPeriodo
                      ? new Date(operacionNoReportadaLocal.periodoInicio)
                      : null
                  }
                  minDate={moment(
                    new Date(operacionNoReportadaLocal.periodoInicio)
                  )
                    .add(1, "months")
                    .toDate()}
                  maxDate={moment(new Date()).subtract(1, "days").toDate()}
                />
              </div>

              <div className="form-group col">
                <label htmlFor="fechaLiquidacion">Fecha Liquidación</label>
                <DatePicker
                  placeholderText="Seleccione una fecha"
                  locale="es"
                  selected={
                    operacionNoReportadaLocal.fechaLiquidacion
                      ? new Date(operacionNoReportadaLocal.fechaLiquidacion)
                      : null
                  }
                  onChange={(fecha) =>
                    setOperacionNoReportadaLocal({
                      ...operacionNoReportadaLocal,
                      fechaLiquidacion: moment(fecha).isValid()
                        ? moment(fecha).format("YYYY-MM-DDTHH:mm:ss")
                        : null,
                    })
                  }
                  id="fechaLiquidacion"
                  name="fechaLiquidacion"
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  wrapperClassName="w-100"
                  showYearDropdown
                  showMonthDropdown
                  scrollableYearDropdown
                  maxDate={moment(new Date()).subtract(1, "days").toDate()}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="tipoOperacion">Tipo Operación</label>
              <Form.Control
                as="select"
                className="form-control"
                name="tipoOperacion"
                id="tipoOperacion"
                value={operacionNoReportadaLocal.tipoOperacion?.codigo ?? "0"}
                onChange={(e) =>
                  setOperacionNoReportadaLocal({
                    ...operacionNoReportadaLocal,
                    tipoOperacion: {
                      codigo: e.target.value,
                      descripcion: e.target.selectedOptions[0].text,
                    },
                  })
                }
              >
                <option value="0" disabled>
                  [Tipo Operación]
                </option>
                {tiposOperacion.map((item) => (
                  <option key={item.codigo} value={item.codigo}>
                    {item.descripcion}
                  </option>
                ))}
              </Form.Control>
            </div>
            <div className="form-group">
              <label htmlFor="motivoLiquidacion">Motivo Liquidación</label>
              <Form.Control
                as="select"
                className="form-control"
                name="motivoLiquidacion"
                id="motivoLiquidacion"
                value={operacionNoReportadaLocal.motivoLiquidacion.codigo ?? ""}
                onChange={(e) =>
                  setOperacionNoReportadaLocal({
                    ...operacionNoReportadaLocal,
                    motivoLiquidacion: {
                      codigo: Number(e.target.value),
                      descripcionLarga: e.target.selectedOptions[0].text,
                    },
                  })
                }
              >
                <option value="-1" disabled>
                  [Motivo Liquidación]
                </option>
                {motivosLiquidacion.map((item) => (
                  <option key={item.codigo} value={item.codigo}>
                    {item.descripcionLarga}
                  </option>
                ))}
              </Form.Control>
            </div>

            {motivosQueRequierenOperacionNueva.includes(
              operacionNoReportadaLocal.motivoLiquidacion.codigo
            ) ? (
              <div className="form-row">
                <div className="form-group col">
                  <label htmlFor="operacionNueva">Operación Nueva</label>
                  <Form.Control
                    className="form-control"
                    name="operacionNueva"
                    id="operacionNueva"
                    value={operacionNoReportadaLocal.operacionNueva ?? ""}
                    onChange={(e) =>
                      setOperacionNoReportadaLocal({
                        ...operacionNoReportadaLocal,
                        operacionNueva: e.target.value.toUpperCase().trim(),
                      })
                    }
                  />
                </div>
              </div>
            ) : null}

            <div className="form-row">
              <div className="form-group col">
                <label htmlFor="saldoPrincipalLiquidado">
                  Saldo Principal Liquidado
                </label>
                <Form.Control
                  className="form-control"
                  name="saldoPrincipalLiquidado"
                  id="saldoPrincipalLiquidado"
                  value={
                    operacionNoReportadaLocal.saldoPrincipalLiquidado ?? ""
                  }
                  onChange={manejarCambioDeSaldo}
                />
              </div>

              <div className="form-group col">
                <label htmlFor="saldoProductoLiquidado">
                  Saldo Productos Liquidado
                </label>
                <Form.Control
                  className="form-control"
                  name="saldoProductoLiquidado"
                  id="saldoProductoLiquidado"
                  value={operacionNoReportadaLocal.saldoProductoLiquidado ?? ""}
                  onChange={manejarCambioDeSaldo}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Confirmar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default ModificarOperacionNoReportadaModal;
